export default "__VITE_ASSET__DFUBSh$S__"